module.exports = __webpack_public_path__ + "static/media/pill-icon-in-person-help.a8299d4e.svg";